import TypesOfSupportComponent from "../../components/request-support/types-of-support";

const TypesOfSupportPage = () => <TypesOfSupportComponent />

export default TypesOfSupportPage;